import OrganizationWaitingTime from "../../../components/organization/reports/daily/OrganizationWaitingTime";
import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import { REPORT_TYPE_IDS } from "../../../store/constants";
import { WAITING_TIME_SUMMARY_COLUMN_DEFINITIONS } from "../../../store/renderConfig";

const DailyOrganizationWaitingTimePage = ({ showFilterForm = true, showTitle = 1 }) => (
  <DailyGeneratedReportPage
    reportTypeId={REPORT_TYPE_IDS.daily_organization_waiting_time}
    title="Waiting Time"
    helmetTitle="Daily Organization Waiting Time"
    descriptionKey="WaitingTime"
    columnDefinitions={WAITING_TIME_SUMMARY_COLUMN_DEFINITIONS}
    defaultSortColumn="totalWaitingTime"
    showFilterForm={showFilterForm}
    showTitle={showTitle}
  >
    {({ data, renderConfig, onRenderConfigChange }) => (
      <OrganizationWaitingTime
        data={data[0]}
        renderConfig={renderConfig}
        onRenderConfigChange={onRenderConfigChange}
      />
    )}
  </DailyGeneratedReportPage>
);

export default DailyOrganizationWaitingTimePage;
